import {
  Button,
  Dialog,
  useTheme,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  DialogContentText,
} from '@mui/material'
import { FC } from 'react'
import { sidebarTexts } from '../../utils/constants'
import KeycloakService from '../../utils/keycloakService'

interface LogoutDialogProps {
  open: boolean
  setOpen: (open: boolean) => void
}

const LogoutDialog: FC<LogoutDialogProps> = ({ open, setOpen }) => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Dialog
      open={open}
      fullScreen={fullScreen}
      onClose={() => setOpen(false)}
      id='logout-dialog-confirmation'
      PaperProps={{ 'data-testid': 'logout-dialog-paper' }}
    >
      <DialogTitle>{sidebarTexts?.logoutConfirm}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          {sidebarTexts?.currentlyLoggedIn}:&nbsp;
          <b>{KeycloakService?.getFullname()}</b>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} id='close-logout-dialog'>
          {sidebarTexts?.no}
        </Button>
        <Button
          autoFocus
          id='confirm-logout'
          onClick={() => KeycloakService?.doLogout()}
        >
          {sidebarTexts?.yes}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default LogoutDialog
